import PropTypes from 'prop-types';
import NImage from '@base/Image';
import { useIsMobile } from '@stores/AppCommonData';
import AboutUnacademy from './AboutUnacademy';
import {
  Title,
  LeadGenCoverContent,
  LeadGenWrapper,
  LeadGenImageCover
} from './styles';

const LeadGenCover = ({
  scrollRef,
  children,
  heroContent,
  form,
  features,
  featuresBg
}) => {
  const { title, image } = heroContent;
  const isSuccessful = form === 'SUCCESSFUL';
  const isMobile = useIsMobile();
  return (
    <LeadGenWrapper $form={isSuccessful}>
      {isSuccessful ? null : (
        <LeadGenCoverContent>
          <LeadGenImageCover>
            <NImage src={image.default} layout="fill" alt="illustration" />
          </LeadGenImageCover>
          <Title ref={scrollRef}>{title}</Title>
          {!isMobile && (
            <AboutUnacademy features={features} featuresBg={featuresBg} />
          )}
        </LeadGenCoverContent>
      )}
      {children}
      {isMobile && !isSuccessful && (
        <AboutUnacademy features={features} featuresBg={featuresBg} />
      )}
    </LeadGenWrapper>
  );
};

LeadGenCover.propTypes = {
  scrollRef: PropTypes.objectOf(PropTypes.any).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  heroContent: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.string.isRequired
};

export default LeadGenCover;
